import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ThemeProvider } from 'styled-components';
import { theme } from '@cta-portal/webapp-common/lib/app/theme';
import ContextProvider from '../context';
import GlobalStyle from './global-style';
import Router from './router';
import MagicLinkDialogs from './magic-link-dialogs';
import './i18n';
export default function App() {
    return (_jsx(ContextProvider, { children: _jsxs(ThemeProvider, { theme: theme, children: [_jsx(GlobalStyle, { theme: theme }), _jsx(Router, {}), _jsx(MagicLinkDialogs, {})] }) }));
}
